import { useRecoilState } from 'recoil'

import { $SelectedPathIds } from './atoms'

export function useSelectedPathIds() {
  return useRecoilState($SelectedPathIds)
}
